var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#1A1D1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0005 14C21.7914 14 20.0005 15.7909 20.0005 18H18.6489C17.1359 18 15.8597 19.1266 15.672 20.6279L14.422 30.6279C14.1982 32.4185 15.5944 34 17.3989 34H30.6022C32.4067 34 33.8028 32.4185 33.579 30.6279L32.329 20.6279C32.1414 19.1266 30.8652 18 29.3522 18H28.0005C28.0005 15.7909 26.2097 14 24.0005 14ZM26.0005 20V21C26.0005 21.5523 26.4483 22 27.0005 22C27.5528 22 28.0005 21.5523 28.0005 21V20H29.3522C29.8565 20 30.2819 20.3755 30.3445 20.876L31.5945 30.876C31.6691 31.4728 31.2037 32 30.6022 32H17.3989C16.7974 32 16.332 31.4728 16.4066 30.876L17.6566 20.876C17.7192 20.3755 18.1446 20 18.6489 20H20.0005V21C20.0005 21.5523 20.4483 22 21.0005 22C21.5528 22 22.0005 21.5523 22.0005 21V20H26.0005ZM26.0005 18C26.0005 16.8954 25.1051 16 24.0005 16C22.896 16 22.0005 16.8954 22.0005 18H26.0005Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/Customer_Icon.f57833084f2960de0440c9a74645be34.svg";
export { ForwardRef as ReactComponent };